
import { defineComponent } from "vue";
import api, { EmployeeList, Employee, RequestPaging, PageBounding, RequestSort } from "../../api/backend-api";
import { getSkipParamForPage, getPageBounding } from "../../util/paginationHelpers";
import { AxiosError } from "axios";

interface State {
  msg: string;
  backendResponse: EmployeeList;
  requestFilter: Employee;
  requestPaging: RequestPaging;
  requestSorting: RequestSort,
  pageBounds: PageBounding[];
  errors: AxiosError[];
}

export default defineComponent({
  name: "SheqsyEmployee",
  mounted() {
    this.$nextTick(() => {
      this.getList();
    });
  },
  data: (): State => {
    const employee_list = { } as EmployeeList;
    const employee_struct = { } as Employee;
    const paging_struct = { Limit: 20, Skip: 0, Options: [ 20, 50, 100 ] } as RequestPaging;
    const sort_struct = { Pattern: '-id' } as RequestSort;
    return {
      msg: "Sheqsy Employee List",
      backendResponse: employee_list,
      requestFilter: employee_struct,
      requestPaging: paging_struct,
      requestSorting: sort_struct,
      pageBounds: [],
      errors: [],
    };
  },
  methods: {
    getSkipParamForPage,
    getPageBounding,
    setPage(command: string|number) {
      this.requestPaging.Skip = getSkipParamForPage(command, this.requestPaging.Skip, this.requestPaging.Limit);
      this.getList();
    },
    clearFiltersAndRefresh() {
      const filter_struct = { } as Employee;
      this.requestFilter = filter_struct;
      this.getList()
    },
    getList() {
      this.backendResponse = { } as EmployeeList;
      const request_params = api.createRequestParams(this.requestFilter, this.requestPaging, this.requestSorting)
      api
        .getEmployeeList(request_params)
        .then((response) => {
          this.backendResponse = response.data;
          this.pageBounds = this.getPageBounding(this.backendResponse.count, this.requestPaging.Limit, this.requestPaging.Skip)
        })
        .catch((error: AxiosError) => {
          this.errors.push(error);
        });
    },
  },
});
